// src/components/LandingFooter.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/components/LandingFooter.scss';

const LandingFooter = () => {
    return (
        <footer className="landing-footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-logo">
                        <Link to="/" className="footer-logo-link">
                            <h3>Suisui</h3>
                        </Link>
                        <p>シンプルで簡単AI支援のウェブサイト作成</p>
                    </div>
                    <div className="footer-links">
                        <div className="footer-column">
                            <h4>製品</h4>
                            <ul>
                                <li><Link to="/#features">機能</Link></li>
                            </ul>
                        </div>
                        <div className="footer-column">
                            <h4>サポート</h4>
                            <ul>
                                <li><a href="https://forms.gle/x2vWq5Ce5NZ2QF4K8" target="_blank" rel="noopener noreferrer">お問い合わせ</a></li>
                                <li><Link to="/terms-of-service">利用規約</Link></li>
                                <li><Link to="/privacy-policy">プライバシーポリシー</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; 2025 Suisui.</p>
                </div>
            </div>
        </footer>
    );
};

export default LandingFooter;
